import React, { useEffect, useState } from "react";
import { Route, Switch, Redirect } from "react-router-dom"; // Added Redirect
import LandingPage from "./LandingPage";
import NewUDHome from "./NewUDHome";
import NewTCPHome from "./NewTCPHome";
import LandingPage2 from "./LandingPage2";
import AwasBandhu from "./AwasBandhu";
import DALogin from "./DALogin";
import AVPLogin from "./AVPLogin";
import DALogin2 from "./DALogin2/DALogin2";
import { DigitApp } from "../../../App";
import { createTheme, ThemeProvider as MuiThemeProvider } from "@mui/material/styles";

const Home = () => {
  const [applicationFlow, setApplicationFlow] = useState(
    Digit?.SessionStorage.get("CITIZEN.COMMON.HOME.FLOW") || null
  );
  const isUdFlow = applicationFlow === "DA";

  useEffect(() => {
    if (applicationFlow) {
      Digit?.SessionStorage.set("CITIZEN.COMMON.HOME.FLOW", applicationFlow);
    }
  }, [applicationFlow]);

  return applicationFlow ? (
    <Switch>
      <Route path="/*">
        {isUdFlow ? (
          <Redirect to="/digit-ui/citizen" />
        ) : (
          <AVPLogin setApplicationFlow={setApplicationFlow} />
        )}
      </Route>
    </Switch>
  ) : (
    <AwasBandhu setApplicationFlow={setApplicationFlow} />
  );
};

export default Home;
